
import styled from "styled-components"
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setYetkiliBilgileriValues } from "../../../../features/firma/FirmaSlice";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive}) => isActive ? "#E85446" : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const YetkiliTextInput = ({data, name, labelText, inputWidth, keyData, type}) => {
    const {theme} = useSelector((state)=> state.layout)

    const dispatch = useDispatch()

    const handleSearch = (event) => {
        const term = event.target.value;
        dispatch(setYetkiliBilgileriValues({keyData, value:term}))
    };

  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth}>
        <input type={type} id={type} onChange={handleSearch} value={data} name={name}/> 
        <label htmlFor={type}>{labelText}</label>
    </Container>
  )
}

export default YetkiliTextInput